 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		62: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~BasicSlider~CardSlider~CharitySli~0cda79d0","1":"vendors~CharitySlider~Modal~ModalOpener~S~224bb889","2":"FacilitiesAnimation~Footer~Intersection~I~08a09df0","3":"vendors~CharitySlider~Modal~ModalOpener~S~3b3e95f8","4":"Dropdown","5":"Modal","6":"SideSlider","7":"vendors~HotelFeed~LayerScroller","8":"Alert","9":"Antispam","10":"BasicSlider","11":"CardSlider","12":"CharitySlider","13":"ContentSwitch","14":"CookieBubble","15":"DatePicker","16":"DragTable","17":"EmergencyAlert","18":"FacilitiesAnimation","19":"FileInput","20":"Footer","21":"Form","22":"FullModal","23":"FullModalToggle","24":"HistorySlider","25":"HotelCardAnimation","26":"HotelFeed","27":"Input","28":"Intersection","29":"IntersectionGroup","30":"LayerScroller","31":"Lightbox","32":"MainNavigation","33":"Masonery","34":"ModalOpener","35":"ModalSlider","36":"NumberInput","37":"Page","38":"PageEdit","39":"Parallax","40":"PopupOffer","41":"PriceController","42":"RemoveElement","43":"ReservationForm","44":"ReservationTabs","45":"Reveal","46":"ScrollContainer","47":"ScrollTo","48":"Section","49":"SelectedItems","50":"SideScroller","51":"Sticky","52":"Tabs","53":"TagList","54":"TagListItem","55":"TextClipping","56":"vendors~DatePicker","57":"vendors~FacilitiesAnimation","58":"vendors~LayerScroller","59":"vendors~Lightbox","60":"vendors~Masonery","61":"vendors~Section"}[chunkId]||chunkId) + "." + {"0":"38bad3dc8fcdb8dff80b","1":"db34b6a59e79712fcfe2","2":"dd14d25d435eb463b457","3":"42775e219c9db1ee0237","4":"17285814f809ec6bba57","5":"881b865b9ab569a5daed","6":"995da216ddbbe9f712d7","7":"da9b0ecf27c77ed468d6","8":"f350cb1c5034eb5ae815","9":"a629bfbbe39a43e9c874","10":"35fee67dfa47edcd222b","11":"4701e8d2219c05bbd67b","12":"69793b7a85cd808b94f2","13":"f2b8e6350a426b2bee49","14":"014bb03aca9b5160e8e7","15":"a97a64558e2c0c777560","16":"fac57c8258dc4dba29ce","17":"3ebe7dbfefc8d0924ea7","18":"4556450a98ffc3ad0dab","19":"d9634b122c6840a92046","20":"c407646112eb8e06d8fb","21":"e46fabee4c6357c5fd7a","22":"7ea09c62100771dfb340","23":"e6574cd1e171101bf325","24":"8f65a8dd38a13a4d2374","25":"4687647f9e44c8303924","26":"4c13867e32d038d1d178","27":"a5b15d537ee6868d6745","28":"6b380773b62403d4aece","29":"b74aa8f523b5330cc368","30":"7d6e63aadaf16babb888","31":"55f0db6481c066b7d2a2","32":"3f882432474da7b14572","33":"953357534da31f061163","34":"adf1c5b5d5edac137359","35":"4431df528c66aacaecd4","36":"7e055b0612a7fa9b8d30","37":"32361f933db9caa77113","38":"2f60624c6f6e36bee60d","39":"9258bbe0bab91bef7a24","40":"52e4481be45b440a8c80","41":"0456d1e04da76c7ab9a2","42":"42c756fb80c14b197c56","43":"4103e8ff86fe2f68492f","44":"9be29173bacd45c6caf2","45":"bc91b66c1bc678e8044d","46":"50e74b35f4c053e5798e","47":"b99a44f62f61e8a28be5","48":"b46487dec6c91c27daf8","49":"19dbe68adb8abeed5388","50":"d287fca9fda33bbd43e5","51":"1c2472a5c0402eddde33","52":"20ca540a0a0d5105688f","53":"5e952f9990e0c4837b75","54":"75a654ebe74a57b92410","55":"b05245896a38c9bbf356","56":"9ad54132acc1622714d0","57":"21b39bc04b130374edcb","58":"d2d4650530b96202039e","59":"e9ebe90a23699e308a6b","60":"f6be9fc380735dfb4461","61":"174c262ae3a8176b900e"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/frontend/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 378);
